import type { ReactNode } from "react";

/** Crisp inline SVG icons for the Send It Safely desktop. No font or emoji dependency. */
export type IcName =
  | "mail" | "folder" | "share" | "users" | "user" | "link" | "lock" | "eye" | "comment" | "pencil"
  | "check" | "warn" | "close" | "search" | "book" | "help" | "apps" | "download" | "info" | "shield"
  | "trash" | "chevron" | "back" | "fwd" | "up" | "doc" | "clock" | "globe" | "minus" | "square"
  | "restore" | "plug" | "inbox" | "spark";

const P: Record<IcName, ReactNode> = {
  mail: (<><rect x="3" y="5.5" width="18" height="13" rx="2.2" /><path d="m4 7.5 8 5.8 8-5.8" /></>),
  folder: (<path d="M3 7.6A2.6 2.6 0 0 1 5.6 5H9l2.1 2.3h7.3A2.6 2.6 0 0 1 21 9.9v7.5a2.6 2.6 0 0 1-2.6 2.6H5.6A2.6 2.6 0 0 1 3 17.4z" />),
  share: (<><circle cx="18" cy="5.5" r="2.5" /><circle cx="6" cy="12" r="2.5" /><circle cx="18" cy="18.5" r="2.5" /><path d="m8.2 10.8 7.6-4.1M8.2 13.2l7.6 4.1" /></>),
  users: (<><circle cx="9" cy="8.5" r="3.2" /><path d="M3 19.5c.4-3.4 3-5.3 6-5.3s5.6 1.9 6 5.3" /><path d="M16 5.6a3.1 3.1 0 0 1 0 5.8M18.5 14.6c1.5.8 2.3 2.3 2.5 4.4" /></>),
  user: (<><circle cx="12" cy="8.5" r="3.6" /><path d="M5 20c.5-3.9 3.3-6 7-6s6.5 2.1 7 6" /></>),
  link: (<><path d="M10.2 13.8a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" /><path d="M13.8 10.2a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" /></>),
  lock: (<><rect x="5" y="10.5" width="14" height="9.5" rx="2.2" /><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" /></>),
  eye: (<><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" /><circle cx="12" cy="12" r="2.8" /></>),
  comment: (<path d="M4 5.8A2.3 2.3 0 0 1 6.3 3.5h11.4A2.3 2.3 0 0 1 20 5.8v8.4a2.3 2.3 0 0 1-2.3 2.3H10l-4.5 4v-4h-.2A2.3 2.3 0 0 1 4 14.2z" />),
  pencil: (<><path d="m4 20 1-4.2L16.6 4.2a2 2 0 0 1 2.8 0l.4.4a2 2 0 0 1 0 2.8L8.2 19z" /><path d="m14.5 6.3 3.2 3.2" /></>),
  check: (<path d="m5 12.6 4.4 4.4L19 7.4" />),
  warn: (<><path d="M12 4.2 21 19.5H3z" /><path d="M12 10v4.4M12 16.9v.1" /></>),
  close: (<path d="m6 6 12 12M18 6 6 18" />),
  search: (<><circle cx="10.8" cy="10.8" r="6" /><path d="m15.3 15.3 5 5" /></>),
  book: (<><path d="M4 5.5C4 4.7 4.7 4 5.5 4H11a2 2 0 0 1 1 .3 2 2 0 0 1 1-.3h5.5c.8 0 1.5.7 1.5 1.5V18c0 .8-.7 1.5-1.5 1.5H13a1 1 0 0 0-1 1 1 1 0 0 0-1-1H5.5C4.7 19.5 4 18.8 4 18z" /><path d="M12 4.5v15" /></>),
  help: (<><circle cx="12" cy="12" r="9" /><path d="M9.4 9.6a2.7 2.7 0 1 1 3.9 2.4c-.9.5-1.3 1-1.3 2" /><path d="M12 17v.1" /></>),
  apps: (<><rect x="4" y="4" width="6.5" height="6.5" rx="1.5" /><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.5" /><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.5" /><path d="M16.7 13.5v6.5M13.5 16.7H20" /></>),
  download: (<><path d="M12 4v10.5M7.5 10.5 12 15l4.5-4.5" /><path d="M5 19.5h14" /></>),
  info: (<><circle cx="12" cy="12" r="9" /><path d="M12 11v5.5M12 7.8v.1" /></>),
  shield: (<path d="M12 3.5 19 6v5.4c0 4.2-2.8 7.4-7 9.1-4.2-1.7-7-4.9-7-9.1V6z" />),
  trash: (<><path d="M5 7h14M10 7V4.8h4V7M7 7l.8 12.2h8.4L17 7" /><path d="M10.2 10.5v6M13.8 10.5v6" /></>),
  chevron: (<path d="m9.5 6 6 6-6 6" />),
  back: (<path d="m14.5 6-6 6 6 6" />),
  fwd: (<path d="m9.5 6 6 6-6 6" />),
  up: (<path d="M12 19V6M6.5 11.5 12 6l5.5 5.5" />),
  doc: (<><path d="M7 3.5h7l4 4V19.5A1.5 1.5 0 0 1 16.5 21h-9A1.5 1.5 0 0 1 6 19.5v-14A1.5 1.5 0 0 1 7.5 4z" /><path d="M14 3.5V8h4.5" /><path d="M9 12.5h6M9 15.5h6" /></>),
  clock: (<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3.2 2" /></>),
  globe: (<><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c2.6 2.6 3.8 5.6 3.8 9S14.6 18.4 12 21c-2.6-2.6-3.8-5.6-3.8-9S9.4 5.6 12 3z" /></>),
  minus: (<path d="M6 12h12" />),
  square: (<rect x="6.5" y="6.5" width="11" height="11" rx="1.4" />),
  restore: (<><rect x="8.5" y="8.5" width="9.5" height="9.5" rx="1.3" /><path d="M6 15.5V7.3C6 6.6 6.6 6 7.3 6H15.5" /></>),
  plug: (<><path d="M9 3.5v4M15 3.5v4" /><path d="M6.5 7.5h11v3.2A5.5 5.5 0 0 1 12 16.2a5.5 5.5 0 0 1-5.5-5.5z" /><path d="M12 16.2v4.3" /></>),
  inbox: (<><path d="M4 13.5 6.4 5.8A1.5 1.5 0 0 1 7.8 4.8h8.4a1.5 1.5 0 0 1 1.4 1l2.4 7.7" /><path d="M4 13.5V18a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 20 18v-4.5h-4.2a3.8 3.8 0 0 1-7.6 0z" /></>),
  spark: (<path d="M12 3.5 13.8 9l5.7 1.8-5.7 1.8L12 18.5l-1.8-5.9L4.5 10.8 10.2 9z" />),
};

export function Ic({ n, size = 16, className }: { n: IcName; size?: number; className?: string }) {
  return (
    <svg
      className={`sis-ic${className ? ` ${className}` : ""}`}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {P[n]}
    </svg>
  );
}

export type FileExt = "docx" | "xlsx" | "pdf";

/** A small page glyph with the app colour band (Word blue, Excel green, PDF red). */
export function FileGlyph({ ext, size = 28 }: { ext: FileExt; size?: number }) {
  const c = ext === "docx" ? "#2b6fd6" : ext === "xlsx" ? "#1f9d63" : "#d93b3b";
  const label = ext === "docx" ? "W" : ext === "xlsx" ? "X" : "PDF";
  return (
    <svg className="sis-fglyph" viewBox="0 0 32 40" width={Math.round(size * 0.8)} height={size} aria-hidden="true">
      <path d="M4 3.5A2.5 2.5 0 0 1 6.5 1H21l9 9v26.5A2.5 2.5 0 0 1 27.5 39h-21A2.5 2.5 0 0 1 4 36.5z" fill="#eef1f5" />
      <path d="M21 1v6.5A2.5 2.5 0 0 0 23.5 10H30z" fill="#c4ccd6" />
      <path d="M9 14h14M9 17.6h10" stroke="#aab4c0" strokeWidth="1.7" strokeLinecap="round" />
      <rect x="4" y="22" width="26" height="12.5" rx="2" fill={c} />
      <text
        x="17"
        y="31.4"
        textAnchor="middle"
        fontSize={label === "PDF" ? 8 : 10.5}
        fontWeight="700"
        fill="#fff"
        fontFamily="Segoe UI, system-ui, sans-serif"
      >
        {label}
      </text>
    </svg>
  );
}

const ORG_COLOR: Record<string, string> = {
  northstar: "#2f7d6d",
  brightlane: "#a8672a",
  clearpath: "#4b5fb0",
  oldpartner: "#6b7480",
};

export function initialsOf(name: string): string {
  const parts = name.split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] ?? "?") + (parts[1]?.[0] ?? "")).toUpperCase();
}

export function Avatar({ name, org, size = 34 }: { name: string; org?: string; size?: number }) {
  return (
    <span
      className="sis-avatar"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.38), background: ORG_COLOR[org ?? ""] ?? "#3a4655" }}
      aria-hidden="true"
    >
      {initialsOf(name)}
    </span>
  );
}
